import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProductTransactionReportPane from './Export/ProductTransactionReportPane';
import CreateProductTransactionExportConfigurationPane from './Export/Panes/CreateProductTransactionExportConfigurationPane';
import UpdateProductTransactionExportConfigurationPane from './Export/Panes/UpdateProductTransactionExportConfigurationPane';
import {
  Breadcrumbs,
  ProductTransactionOverviewCrumb,
  ProductTransactionSettingsCrumb,
} from '../../../../components/Breadcrumbs';

export default function ProductTransactionSettingsScreen() {
  return (
    <div className='flex h-full flex-col overflow-hidden'>
      <Breadcrumbs>
        <ProductTransactionOverviewCrumb />
        <ProductTransactionSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex-grow overflow-hidden'>
        <Routes>
          <Route path='report/*' element={<ProductTransactionReportPane />} />
          <Route path='report/create' element={<CreateProductTransactionExportConfigurationPane />} />
          <Route path='report/update/:id' element={<UpdateProductTransactionExportConfigurationPane />} />
        </Routes>
      </div>
    </div>
  );
}
